"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _draftJs = require("draft-js");

var _immutable = require("immutable");

var _constants = require("composer-plugins/lib/constants");

function _default(editorState) {
  var contentState = editorState.getCurrentContent();
  var blocks = contentState.getBlockMap();
  var newBlocks = blocks.mapEntries(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        blockKey = _ref2[0],
        block = _ref2[1];

    var entityKey = block.getEntityAt(0);

    if (!entityKey) {
      return [blockKey, block];
    }

    var entity = contentState.getEntity(entityKey);

    if (entity.getType() !== _constants.ENTITY_TYPES.image) {
      return [blockKey, block];
    }

    var blockData = block.getData();

    if (blockData.size > 0 && blockData.get('atomicType') === _constants.ATOMIC_TYPES.image) {
      // this entity data is stale: the block already has image data in its block
      return [blockKey, block];
    }

    var newBlock = block.set('data', new _immutable.Map(Object.assign({}, entity.getData(), {
      atomicType: _constants.ATOMIC_TYPES.image
    })));
    return [newBlock.getKey(), newBlock];
  });

  if ((0, _immutable.is)(blocks, newBlocks)) {
    return editorState;
  }

  var newContentState = _draftJs.ContentState.createFromBlockArray(newBlocks.toArray());

  return _draftJs.EditorState.createWithContent(newContentState);
}

module.exports = exports.default;